import { render, staticRenderFns } from "./PushHandler.vue?vue&type=template&id=48d8e461&scoped=true"
import script from "./PushHandler.vue?vue&type=script&lang=js"
export * from "./PushHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8e461",
  null
  
)

export default component.exports